import React, { useState } from "react";
import InputWidget from "./InputWidget"

const PasswordWidget = (props) => {
    return (
        <InputWidget {...props} type="password" />
    )
}

export default PasswordWidget;